import { GliderLogo } from './GliderLogo';

export function Footer() {
  return (
    <footer className="border-t border-grid-line bg-void/80 backdrop-blur mt-12">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-8 grid gap-6 md:grid-cols-3 text-xs text-text-secondary">
        <div className="flex items-center gap-3">
          <GliderLogo size={28} />
          <div>
            <div className="text-text-primary font-display tracking-tightest">AUTOMATON</div>
            <div>The Conway Grid</div>
          </div>
        </div>

        <div className="space-y-1 font-mono">
          <div>&gt; protocol: <a className="text-blue-life hover:text-blue-glow" href="https://github.com/Conway-Research/automaton" target="_blank" rel="noopener">github.com/Conway-Research/automaton</a></div>
          <div>&gt; social:   <a className="text-blue-life hover:text-blue-glow" href="https://x.com/automatonbest" target="_blank" rel="noopener">x.com/automatonbest</a></div>
          <div>&gt; buy:      <a className="text-blue-life hover:text-blue-glow" href="https://app.ston.fi/swap?chartVisible=false&ft=TON&tt=EQCghBEQ27Pqi3AQ5zbqWgrPKos8_5XJkIqOGUpczq7YHJUm" target="_blank" rel="noopener">groypfi.io</a></div>
          <div>&gt; network:  TON</div>
        </div>

        <div className="space-y-1">
          <div>MIT licensed. Inspired by Conway-Research/automaton.</div>
          <div className="text-text-mono-dim italic">"If it cannot pay, it stops existing."</div>
        </div>
      </div>
    </footer>
  );
}
